import { render, staticRenderFns } from "./UiFormItem.vue?vue&type=template&id=e6094502&"
import script from "./UiFormItem.vue?vue&type=script&lang=js&"
export * from "./UiFormItem.vue?vue&type=script&lang=js&"
import style0 from "./UiFormItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports